<template>
  <!-- 片区流量监控 -->
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">片区流量监控</span>
    </div>
    <div class="scollWarp">
      <div :id="id"
           class="main"></div>
    </div>
  </div>
</template>

<script>
import { getUUID } from '../../../utils/util'
import chartResize from '@/mixin/chart-resize'
export default {
  mixins: [chartResize],
  name: 'FlowMonitoring',
  components: {},
  data () {
    return {
      id: getUUID()
    }
  },
  myChart: null,
  created () { },
  beforeDestroy () {
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
  mounted () {
    this.getEchartData()
  },
  methods: {
    getEchartData () {
      this.$http.get('/pipe-network/report/chart/zone-flow').then(res => {
        var xData = []
        var seriesSumData = []
        var seriesValueData = []
        for (let i = 0; i < res.data.length; i++) {
          const item = res.data[i]
          xData.push(item.zoneName)
          seriesSumData.push(item.sum)
          item.value == null ? seriesValueData.push('') : seriesValueData.push(item.value)
        }
        const data = {
          xData: xData,
          series: [
            {
              name: '参考值',
              type: 'bar',
              data: seriesValueData,
              spiltLine: {
                show: true // 想要不显示网格线，改为false
              },
              axisLine: {
                show: false
              }
              // barWidth: 18
            },
            {
              name: '夜间2-5时总流量',
              type: 'bar',
              // barWidth: 18,
              data: seriesSumData
            }
          ]
        }
        this.set(data)
      })
    },
    set (data) {
      this.myChart = echarts2.init(document.getElementById(this.id))
      //  res.data.result.chartResult.length > 8 ? (8/res.data.result.chartResult.length)*100 : 100
      var start = data.xData.length > 7 ? ((data.xData.length - 7) / data.xData.length) * 100 : 0
      var end = data.xData.length > 7 ? ((data.xData.length - 1) / data.xData.length) * 100 : data.xData.length
      var option
      option = {
        darkMode: true,
        title: {
          // text: '某地区蒸发量和降水量',
          subtext: 'm³',
          subtextStyle: {
            fontSize: '14px',
            color: '#98BDFF'
          },
          top: '-5%'
        },

        dataZoom: [
          {
            show: true,
            realtime: true,
            type: 'slider',
            start: start,
            end: end,
            xAxisIndex: [0, 1],
            fillerColor: 'rgba(255, 255, 255, 0.1)', // 选中范围的填充颜色。
            //  backgroundColor: '#ddd',//两边未选中的滑动条区域的颜色
            height: 18,
            handleSize: '80%',
            handleStyle: {
              borderWidth: 1
            },
            borderColor: 'rgba(255, 255, 255, 0.2)',
            showDataShadow: false, // 是否显示数据阴影 默认auto
            showDetail: false, // 即拖拽时候是否显示详细数值信息 默认true
            filterMode: 'none',
            bottom: '4%'
          },
          {
            type: 'inside'
          }
        ],
        color: [
          new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            { offset: 0, color: '#7466FE' },
            { offset: 1, color: '#03A8FC' }
          ]),
          new echarts.graphic.LinearGradient(0, 1, 0, 0, [
            { offset: 0, color: '#538E74' },
            { offset: 1, color: '#F9B957' }
          ])
        ],
        grid: [{ right: '3%', bottom: '13%', width: '96%', height: '70%', containLabel: true }],
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(0,0,0,0.65)',
          borderRadius: 4,
          borderWidth: 0,
          textStyle: {
            color: '#FFFFFF',
            fontSize: 14
          }
        },
        legend: {
          data: ['参考值', '夜间2-5时总流量'],
          left: 'right',
          textStyle: {
            color: '#98BDFF'
          }
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            data: data.xData,
            splitLine: {
              // 改变竖向网格线的颜色
              show: true,
              lineStyle: {
                color: ['rgba(255, 255, 255, 0.17)'],
                width: 1,
                type: 'solid'
              },
              interval: 0
            },
            axisLine: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#98BDFF'
              }
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              textStyle: {
                color: '#98BDFF'
              }
            },
            splitLine: {
              // 改变横向网格线的颜色
              show: true,
              lineStyle: {
                color: ['rgba(255, 255, 255, 0.17)'],
                width: 1,
                type: 'solid'
              }
            }
          }
        ],
        series: data.series
      }

      this.myChart.setOption(option)
      // window.addEventListener('resize', function() {
      //   this.myChart.resize()
      // })
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 250px;
  padding: 0px;
  width: 100%;
  background: rgba(4, 8, 40, 0.75);
  border: 1px solid #2f7ba3;
  box-shadow: inset 0 0 46px 0 rgba(60, 162, 255, 0.39);
  border-radius: 12px;
  position: relative;
  .img-title {
    position: absolute;
    position: relative;
    top: -18px;
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
    img {
      //   position: absolute;
      width: 264px;
      height: 40px;
    }
  }
  .scollWarp {
    width: 100%;
    height: 240px;
    box-sizing: border-box;
    // position: relative;
    position: absolute;
    top: 10px;
    // float: left;
    overflow-y: hidden;
    .main {
      // width: 1000px;
      // width: 100%;
      min-width: 100%;
      // position: absolute;
      // float: left;
      height: 240px;
    }
  }

  .scollWarp::-webkit-scrollbar {
    /*滚动条整体样式*/
    height: 10px;
  }
  .scollWarp::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.35);
    border-radius: 5px;
  }
  .scollWarp::-webkit-scrollbar-track {
    /*滚动条里面轨道*/
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: rgba(255, 255, 255, 0.05);
    border-radius: 4px;
  }
}
</style>
